import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "./chunks/tslib.es6.js";
import r from "./core/Collection.js";
import { referenceSetter as t } from "./core/collectionUtils.js";
import { deprecated as s } from "./core/deprecate.js";
import { JSONSupportMixin as o } from "./core/JSONSupport.js";
import { clone as a } from "./core/lang.js";
import i from "./core/Loadable.js";
import { loadAll as n } from "./core/loadAll.js";
import l from "./core/Logger.js";
import { isSome as p } from "./core/maybe.js";
import { throwIfAborted as c, eachAlways as m } from "./core/promiseUtils.js";
import { isProtocolRelative as u, urlToObject as h } from "./core/urlUtils.js";
import { property as y } from "./core/accessorSupport/decorators/property.js";
import "./core/accessorSupport/ensureType.js";
import { subclass as f } from "./core/accessorSupport/decorators/subclass.js";
import { writer as d } from "./core/accessorSupport/decorators/writer.js";
import b from "./geometry/SpatialReference.js";
import L from "./portal/Portal.js";
import g from "./portal/PortalItem.js";
import { getBasemapTitle as w, esriBasemapDefinitions as I } from "./support/basemapDefinitions.js";
import { getLayerJSON as j } from "./webdoc/support/writeUtils.js";

var _v;

var S = 0;

var _ = l.getLogger("esri.Basemap");

var U = _v = /*#__PURE__*/function (_o) {
  _inherits(v, _o);

  var _super = _createSuper(v);

  function v(e) {
    var _this;

    _classCallCheck(this, v);

    _this = _super.call(this, e), _this.id = null, _this.portalItem = null, _this.spatialReference = null, _this.thumbnailUrl = null, _this.title = "Basemap", _this.id = Date.now().toString(16) + "-basemap-" + S++, _this.baseLayers = new r(), _this.referenceLayers = new r();

    var t = function t(e) {
      e.parent && e.parent !== _assertThisInitialized(_this) && "remove" in e.parent && e.parent.remove(e), e.parent = _assertThisInitialized(_this), "elevation" === e.type && _.error("Layer '".concat(e.title, ", id:").concat(e.id, "' of type '").concat(e.type, "' is not supported as a basemap layer and will therefore be ignored."));
    },
        s = function s(e) {
      e.parent = null;
    };

    _this.baseLayers.on("after-add", function (e) {
      return t(e.item);
    }), _this.referenceLayers.on("after-add", function (e) {
      return t(e.item);
    }), _this.baseLayers.on("after-remove", function (e) {
      return s(e.item);
    }), _this.referenceLayers.on("after-remove", function (e) {
      return s(e.item);
    });
    return _this;
  }

  _createClass(v, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.when().catch(function (e) {
        _.error("#load()", "Failed to load basemap (title: '".concat(_this2.title, "', id: '").concat(_this2.id, "')"), e);
      }), this.resourceInfo && this.read(this.resourceInfo.data, this.resourceInfo.context);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var e;
      var r = this.baseLayers.removeAll();

      var _iterator = _createForOfIteratorHelper(r),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _s = _step.value;

          _s.destroy();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var t = this.referenceLayers.removeAll();

      var _iterator2 = _createForOfIteratorHelper(t),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _s2 = _step2.value;

          _s2.destroy();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.baseLayers.destroy(), this.referenceLayers.destroy(), null == (e = this.portalItem) || e.destroy(), this.portalItem = null;
    }
  }, {
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(e) {
      return e && "resourceInfo" in e && (this._set("resourceInfo", e.resourceInfo), delete (e = _objectSpread({}, e)).resourceInfo), e;
    }
  }, {
    key: "baseLayers",
    set: function set(e) {
      this._set("baseLayers", t(e, this._get("baseLayers")));
    }
  }, {
    key: "_writeBaseLayers",
    value: function _writeBaseLayers(e, r, t) {
      var s = [];
      e ? (t = _objectSpread(_objectSpread({}, t), {}, {
        layerContainerType: "basemap"
      }), this.baseLayers.forEach(function (e) {
        var r = j(e, t.webmap ? t.webmap.getLayerJSONFromResourceInfo(e) : null, t);
        p(r) && s.push(r);
      }), this.referenceLayers.forEach(function (e) {
        var r = j(e, t.webmap ? t.webmap.getLayerJSONFromResourceInfo(e) : null, t);
        p(r) && (r.isReference = !0, s.push(r));
      }), r.baseMapLayers = s) : r.baseMapLayers = s;
    }
  }, {
    key: "referenceLayers",
    set: function set(e) {
      this._set("referenceLayers", t(e, this._get("referenceLayers")));
    }
  }, {
    key: "writeTitle",
    value: function writeTitle(e, r) {
      r.title = e || "Basemap";
    }
  }, {
    key: "load",
    value: function load(e) {
      return this.addResolvingPromise(this._loadFromSource(e)), Promise.resolve(this);
    }
  }, {
    key: "loadAll",
    value: function loadAll() {
      var _this3 = this;

      return n(this, function (e) {
        e(_this3.baseLayers, _this3.referenceLayers);
      });
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = {
        id: this.id,
        title: this.title,
        portalItem: this.portalItem,
        baseLayers: this.baseLayers.slice(),
        referenceLayers: this.referenceLayers.slice()
      };
      return this.loaded && (e.loadStatus = "loaded"), new _v({
        resourceInfo: this.resourceInfo
      }).set(e);
    }
  }, {
    key: "read",
    value: function read(e, r) {
      this.resourceInfo || this._set("resourceInfo", {
        data: e,
        context: r
      }), _get(_getPrototypeOf(v.prototype), "read", this).call(this, e, r);
    }
  }, {
    key: "write",
    value: function write(e, r) {
      return e = e || {}, r && r.origin || (r = _objectSpread({
        origin: "web-map"
      }, r)), _get(_getPrototypeOf(v.prototype), "write", this).call(this, e, r), !this.loaded && this.resourceInfo && this.resourceInfo.data.baseMapLayers && (e.baseMapLayers = this.resourceInfo.data.baseMapLayers.map(function (e) {
        var r = a(e);
        return r.url && u(r.url) && (r.url = "https:".concat(r.url)), r.templateUrl && u(r.templateUrl) && (r.templateUrl = "https:".concat(r.templateUrl)), r;
      })), e;
    }
  }, {
    key: "_loadFromSource",
    value: function () {
      var _loadFromSource2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var _this4 = this;

        var r, t, s, _t, _e;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                r = this.resourceInfo, t = this.portalItem;
                c(e);
                s = [];

                if (r) {
                  _t = r.context ? r.context.url : null;

                  if (s.push(this._loadLayersFromJSON(r.data, _t, e)), r.data.id && !r.data.title) {
                    _e = r.data.id;
                    s.push(w(_e).then(function (e) {
                      e && _this4.read({
                        title: e
                      }, r.context);
                    }));
                  }
                } else t && s.push(this._loadFromItem(t, e));

                _context.next = 6;
                return Promise.all(s);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _loadFromSource(_x) {
        return _loadFromSource2.apply(this, arguments);
      }

      return _loadFromSource;
    }()
  }, {
    key: "_loadLayersFromJSON",
    value: function () {
      var _loadLayersFromJSON2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, r, t) {
        var s, o, a, _yield$import, i, n, _t2, _s3, _l;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                s = this.resourceInfo && this.resourceInfo.context;
                o = this.portalItem && this.portalItem.portal || s && s.portal || null;
                a = s && "web-scene" === s.origin ? "web-scene" : "web-map";
                _context2.next = 5;
                return import("./layers/support/layersCreator.js");

              case 5:
                _yield$import = _context2.sent;
                i = _yield$import.populateOperationalLayers;
                n = [];

                if (c(t), e.baseMapLayers && Array.isArray(e.baseMapLayers)) {
                  _t2 = {
                    context: {
                      origin: a,
                      url: r,
                      portal: o,
                      layerContainerType: "basemap"
                    },
                    defaultLayerType: "DefaultTileLayer"
                  }, _s3 = i(this.baseLayers, e.baseMapLayers.filter(function (e) {
                    return !e.isReference;
                  }), _t2);
                  n.push(_s3);
                  _l = i(this.referenceLayers, e.baseMapLayers.filter(function (e) {
                    return e.isReference;
                  }), _t2);
                  n.push(_l);
                }

                _context2.next = 11;
                return m(n);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _loadLayersFromJSON(_x2, _x3, _x4) {
        return _loadLayersFromJSON2.apply(this, arguments);
      }

      return _loadLayersFromJSON;
    }()
  }, {
    key: "_loadFromItem",
    value: function () {
      var _loadFromItem2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, r) {
        var t, s, o;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return e.load(r);

              case 2:
                t = _context3.sent;
                _context3.next = 5;
                return t.fetchData("json", r);

              case 5:
                s = _context3.sent;
                o = h(e.itemUrl);
                return _context3.abrupt("return", (this._set("resourceInfo", {
                  data: s.baseMap,
                  context: {
                    origin: "web-map",
                    portal: e.portal || L.getDefault(),
                    url: o
                  }
                }), this.read(this.resourceInfo.data, this.resourceInfo.context), this.read({
                  spatialReference: s.spatialReference
                }, this.resourceInfo.context), this.read({
                  title: e.title,
                  thumbnailUrl: e.thumbnailUrl
                }, {
                  origin: "portal-item",
                  portal: e.portal || L.getDefault(),
                  url: o
                }), this._loadLayersFromJSON(this.resourceInfo.data, o, r)));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _loadFromItem(_x5, _x6) {
        return _loadFromItem2.apply(this, arguments);
      }

      return _loadFromItem;
    }()
  }], [{
    key: "fromId",
    value: function fromId(e) {
      var r = I[e];

      if (r) {
        if (r.deprecated) {
          var _r = null;
          "dark-gray" === e ? _r = "dark-gray-vector" : "gray" === e ? _r = "gray-vector" : "streets" === e ? _r = "streets-vector" : "topo" === e && (_r = "topo-vector"), s(_, "The ".concat(e, " basemap has entered mature support and is no longer being updated."), {
            replacement: _r,
            see: "https://arcg.is/1iq8aD",
            warnOnce: !0
          });
        }

        return _v.fromJSON(r);
      }

      return null;
    }
  }]);

  return v;
}(o(i));

e([y({
  json: {
    write: {
      ignoreOrigin: !0,
      target: "baseMapLayers",
      writer: function writer(e, r, t, s) {
        this._writeBaseLayers(e, r, s);
      }
    },
    origins: {
      "web-scene": {
        write: {
          ignoreOrigin: !0,
          target: {
            baseMapLayers: {
              type: r
            }
          },
          writer: function writer(e, r, t, s) {
            this._writeBaseLayers(e, r, s);
          }
        }
      }
    }
  }
})], U.prototype, "baseLayers", null), e([y({
  type: String,
  json: {
    origins: {
      "web-scene": {
        write: !0
      }
    }
  }
})], U.prototype, "id", void 0), e([y({
  type: g
})], U.prototype, "portalItem", void 0), e([y()], U.prototype, "referenceLayers", null), e([y({
  readOnly: !0
})], U.prototype, "resourceInfo", void 0), e([y({
  type: b
})], U.prototype, "spatialReference", void 0), e([y()], U.prototype, "thumbnailUrl", void 0), e([y({
  type: String,
  json: {
    origins: {
      "web-scene": {
        write: {
          isRequired: !0
        }
      }
    }
  }
})], U.prototype, "title", void 0), e([d("title")], U.prototype, "writeTitle", null), U = _v = e([f("esri.Basemap")], U);
var x = U;
export { x as default };